var _g, _ellipse, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 66,
    viewBox: "0 0 69 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_764_33119)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 31.5,
    rx: 33.5,
    ry: 31.5,
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 31.5,
    rx: 29.3125,
    ry: 27.5625,
    fill: "#01537A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_764_33119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5641 11.9795H43.4095C44.6646 11.9795 45.8261 12.4949 46.6392 13.3385C47.4756 14.182 47.9868 15.3303 47.9868 16.5953V47.3618C47.9868 48.6269 47.4756 49.7986 46.6392 50.6187C45.8261 51.4623 44.6646 51.9777 43.4095 51.9777H26.5641C25.3096 51.9777 24.1714 51.4623 23.3344 50.6187C22.4981 49.7986 21.9868 48.6269 21.9868 47.3618V16.5953C21.9868 15.3303 22.4981 14.182 23.3344 13.3385C24.1714 12.4949 25.3096 11.9795 26.5641 11.9795ZM43.4095 14.4867H26.5641C25.9837 14.4867 25.4725 14.7209 25.0775 15.1195C24.7053 15.4941 24.4732 16.0101 24.4732 16.5953V47.3618C24.4732 47.9477 24.7053 48.4631 25.0775 48.8611C25.4725 49.2362 25.9837 49.4705 26.5641 49.4705H43.4095C43.9905 49.4705 44.525 49.2362 44.8967 48.8611C45.2683 48.4631 45.501 47.9477 45.501 47.3618V16.5953C45.501 16.0101 45.2683 15.4941 44.8967 15.1195C44.525 14.7209 43.9905 14.4867 43.4095 14.4867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4891 15.2832C31.8156 15.2832 31.2578 15.8456 31.2578 16.5489C31.2578 17.228 31.8156 17.7904 32.4891 17.7904H37.4846C38.182 17.7904 38.7397 17.228 38.7397 16.5489C38.7397 15.8456 38.182 15.2832 37.4846 15.2832H32.4891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.098 23.7661H32.7451C33.4419 23.7661 33.9996 24.305 33.9996 25.0077V29.694C33.9996 30.3738 33.4419 30.9362 32.7451 30.9362H28.098C27.4239 30.9362 26.8667 30.3738 26.8667 29.694V25.0077C26.8667 24.305 27.4239 23.7661 28.098 23.7661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2292 23.7661H41.8763C42.5498 23.7661 43.1075 24.305 43.1075 25.0077V29.694C43.1075 30.3738 42.5498 30.9362 41.8763 30.9362H37.2292C36.5318 30.9362 35.9746 30.3738 35.9746 29.694V25.0077C35.9746 24.305 36.5318 23.7661 37.2292 23.7661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.098 33.021H32.7451C33.4419 33.021 33.9996 33.5834 33.9996 34.2867V38.9495C33.9996 39.6521 33.4419 40.2145 32.7451 40.2145H28.098C27.4239 40.2145 26.8667 39.6521 26.8667 38.9495V34.2867C26.8667 33.5834 27.4239 33.021 28.098 33.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2292 33.021H41.8763C42.5498 33.021 43.1075 33.5834 43.1075 34.2867V38.9495C43.1075 39.6521 42.5498 40.2145 41.8763 40.2145H37.2292C36.5318 40.2145 35.9746 39.6521 35.9746 38.9495V34.2867C35.9746 33.5834 36.5318 33.021 37.2292 33.021Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_764_33119",
    x: 0,
    y: 0,
    width: 69,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_764_33119"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_764_33119",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_764_33119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 40,
    fill: "white",
    transform: "translate(22 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons2);
export default __webpack_public_path__ + "static/media/Icons2.c71b0521537f0f980b7dcf618a82b724.svg";
export { ForwardRef as ReactComponent };